import React, { Fragment, useRef, useState } from "react";
import { useEffectOnce } from "../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import { 
    setProcessing, setPanes, currentFieldGroupSelected, setFormServerErrors, setFormValue, applyMigration, reapplyMigration,
    loadPage, loadPlan, loadEntity, createEntity, saveEntity, removeEntityFromUI, deleteEntity,
    disposePage, 
    activateDeactivateEntity, getStatusText
} from "../../redux/slices/migrationspageslice";
import { setCurentPage, setCurrentPageIsDirty, setCurrentPage } from "../../redux/slices/currentpageslice";
import { addNotification } from "../../redux/slices/notificationsslice";
import { notificationDurationShort, notificationDurationMiddle, notificationDurationLong, deepCompare } from "../../lib/utils";
import { hideAppDialog, setAppDialog } from "../../redux/slices/appdialogslice";
import { useNavigate } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../api/httpclient";
import { Page } from "../page";
import { MigrationsPageBody } from "./migrationspagebody";
import { formValidator } from "./migrationspageformvalidator";
import { ReactComponent as SqlIcon } from  "../../icons/sql.svg";
import { ReactComponent as DatabaseIcon } from  "../../icons/database.svg";
import { ReactComponent as AggregateIcon } from  "../../icons/aggregate.svg";
import { ReactComponent as FunctionsIcon } from  "../../icons/functions.svg";
import { ReactComponent as HelpIcon } from  "../../icons/help.svg";
import { ReactComponent as ConditionIcon } from  "../../icons/diamond.svg";
import { ReactComponent as LockIcon } from  "../../icons/folderlock.svg";
import { ReactComponent as GroupIcon } from  "../../icons/layergroup.svg";
import { BLOCK_DIRTY_MESSAGE } from "../../settings";
import "./migrationspage.css";

import i18next from "i18next";
import { useTranslation } from "react-i18next";


export const MigrationsPage = props => {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser);
    const currentTheme = useSelector(state => state.currentTheme);
    const pageState = useSelector(state => state.migrationsPage);
    const currentPageState = useSelector(state => state.currentPage);
    const currentPlan = useSelector(state => state.migrationsPage.currentPlan);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const introItems = useRef([
        // {color: currentTheme.colorVariant1, icon: SqlIcon, width:64, height: 32, content: "An expression is any valid SQL statement that returns a boolean, numeric, text, date or date/time value."},
        // {color: currentTheme.colorVariant2, icon: DatabaseIcon, width:90, height: 32, content: "Expressions are referenced by data sources. This is how the datasets are extended."},
        // {color: currentTheme.colorVariant2, icon: AggregateIcon, width:100, height: 32, content: "An expression may or may not be an aggregate. An aggregate expression exists in a grouped data source where each field is either grouped by or is itself an aggregate."},
        // {color: currentTheme.colorVariant3, icon: FunctionsIcon, width:80, height: 32, content: "Aggregate expressions include: Count, Count_Big, Min, Max, Avg, Sum, Approx_Count_Distinct, Grouping, Grouping_ID, StdDev, StdDevP."},
        // {color: currentTheme.colorVariant3, icon: ConditionIcon, width:80, height: 32, content: "Other types of expressions include conditional statements (Case) as well as conversion, text and date functions."},
        // {color: currentTheme.colorVariant3, icon: LockIcon, width:80, height: 32, content: "Once created, you cannot change the data type of an expression. If an alert/widget is attached, additional limitations are imposed when updating."},
        // {color: currentTheme.colorVariant3, icon: GroupIcon, width:80, height: 32, content: "Similarly to any other field, an expression must be assigned to a field group; those include: basic, money, performance, conversion etc. depending on the dataset."},
        // {color: currentTheme.colorVariant3, icon: HelpIcon, width:90, height: 32, content: "The following link https://learn.microsoft.com/en-us/sql/t-sql/functions/functions?view=sql-server-ver16 lists all T-SQL built-in functions."},
      ]);
  
  
    let currentPageId = "migrationsPage";

    
    /*block navigation if dirty*/
    const updateDirtyState = () => {
        let isDirty = pageState.formInitialValues.Name != pageState.formValues.Name //!deepCompare(pageState.formInitialValues, pageState.formValues);
                      || pageState.formInitialValues.Description != pageState.formValues.Description
                      || pageState.formInitialValues.BasicSchemaChanged != pageState.formValues.BasicSchemaChanged
                      || !deepCompare(pageState.formInitialValues.Entities, pageState.formValues.Entities);
                      
        let wasDirty = currentPageState.isDirty;

        if(isDirty != wasDirty)
            dispatch(setCurrentPageIsDirty(isDirty));
    };

    const blockNavigationIfDirty = (msg) => {
        if (currentPageState.isDirty)
        {
            if (window.confirm(msg ? msg : BLOCK_DIRTY_MESSAGE) == true)
                {
                    dispatch(setCurrentPageIsDirty(false));
                    return false;
                }
            else
                return true;
        }
        else
            return false;
    };
    /*block navigation if dirty*/


    /*initial page load*/
    useEffectOnce(() => {
        dispatch(loadPage(t)).then(
            response => {
                dispatch(setCurrentPage({id: currentPageId, isDirty: false}));
            },
            err =>{
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                    let errorMessages = payload?.data?.ErrorMessages;

                    //notify with error
                    if (!errorMessages || errorMessages.length == 0)
                        dispatch(addNotification({text: t("migrations.loading_errormessage"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);
                        dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                    }

                    //go home
                    navigate("/", {replace: true});
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    dispatch(addNotification({text: t("migrations.unknown_error"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                    navigate("/", {replace: true});
                };

                //console.log(action);
                apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
            }
        );

        return () => {
            dispatch(setCurrentPage({id: "", isDirty: false}));
            dispatch(disposePage(true));
        }
    }, []);
    /*initial load*/


    /*splitter*/
    const handleOnSplitterChange = e => {
        setCurrentPage({id: "", isDirty: false});
        dispatch(setPanes(e.newState));
    };
    /*splitter*/


    /*panel bar*/
    const plansPanelRef = useRef(null);

    //on plan change
    const handleOnPlanChange = e => {
        const selectedItemId = e.value;
        if (blockNavigationIfDirty() == true)
            return;

        dispatch(loadPlan(selectedItemId, t)).then(
            response =>{
            },
            err => {
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                        errorMessages = [t("migrations.unknown_error")];
                    else                    
                        errorMessages = getErrorMessages(errorMessages, 1);                                         

                    dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    let errorMessage = t("migrations.unknown_error");
                    dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
            }
        );       
    };

    /*panel bar*/


    /*toolbar*/
    const handleOnNew = e =>{
        if (!currentUser.IsAuthenticated)
        {
            dispatch(addNotification({text: t("migrations.unknown_error"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
            return;
        }

        if (blockNavigationIfDirty() == true)
            return;

        dispatch(createEntity());
    };


    const handleOnSave = e =>{
        if (pageState.mode == 1)
        {
            //create
            if (!currentUser.IsAuthenticated)
            {
                dispatch(addNotification({text:t("migrations.authorization_error") , type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                return;
            }
        }
        
        //make sure no client errors; if so return
        const isValidForm = (formValidator(pageState.formValues) == undefined);
        if (!isValidForm)
        {
            dispatch(addNotification({text: t("migrations.invalid_info"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
            return;
        }

        //no client errors => proceed
        dispatch(saveEntity(t)).then(
            response =>{
                dispatch(setCurrentPageIsDirty(false));
            },
            err =>
            {
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                        errorMessages = [t("migrations.unknown_error")];
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);

                        //if the error is entity does not exist => it has been removed => remove it from currentDataset and from editing
                        if (payload.data.ErrorCodes.EntityDoesNotExist)
                        {
                            dispatch(removeEntityFromUI(pageState.formValues.Id));
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                        }
                        else
                            dispatch(setFormServerErrors(errorMessages));
                    }
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    let errorMessage = t("migrations.unknown_error");
                    dispatch(setFormServerErrors([errorMessage]));                
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
            }
        );
    };

    const handleOnActivate = (e) => {
        dispatch(activateDeactivateEntity(true, t)).then(
            response =>{
            },
            err =>
            {
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                        errorMessages = [t("migrations.unknown_error")];
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);

                        //if the error is entity does not exist => it has been removed => remove it from currentDataset and from editing
                        if (payload.data.ErrorCodes.EntityDoesNotExist)
                        {
                            dispatch(removeEntityFromUI(pageState.formValues.Id));
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                        }
                        else
                            dispatch(setFormServerErrors(errorMessages));
                    }
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    let errorMessage = t("migrations.unknown_error");
                    dispatch(setFormServerErrors([errorMessage]));                
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
            }
        );
    };

    const handleOnDeactivate = (e) => {
        dispatch(activateDeactivateEntity(false, t)).then(
            response =>{
            },
            err =>
            {
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                        errorMessages = [t("migrations.unknown_error")];
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);

                        //if the error is entity does not exist => it has been removed => remove it from currentDataset and from editing
                        if (payload.data.ErrorCodes.EntityDoesNotExist)
                        {
                            dispatch(removeEntityFromUI(pageState.formValues.Id));
                            dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                        }
                        else
                            dispatch(setFormServerErrors(errorMessages));
                    }
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    let errorMessage = t("migrations.unknown_error");
                    dispatch(setFormServerErrors([errorMessage]));                
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
            }
        );
    };

    const handleOnErrorbarClose = e => {
        dispatch(setFormServerErrors([]));
    };

    /*toolbar*/

    /*delete */
    const handleOnDelete = (id) => {
        //id is zero if deleted from toolbar and > 0 if deleted from expressions list
        //if id is zero and mode !=2 => must not happen
        if (!id && pageState.mode != 2)
            return;
        
        let isCurrentEntity = false;

        if (!id)//deleted from the toolbar => it's the current entity and mode is 2
        {
            id = pageState.formValues.Id;
            isCurrentEntity = true;
        }
        else if (pageState.formValues?.Id && pageState.formValues.Id == id)
            isCurrentEntity = true;


        if (isCurrentEntity)
        {
            //if contains dirty => block
            if (blockNavigationIfDirty() == true)
                return;
        }

        dispatch(setAppDialog({
            isVisible: true,
            className: "migrations-page-are-you-sure",
            title: t("migrations.warning"), content: t("migrations.areyousure"),
            actions:{
                yesButton:{ title: t("migrations.yes"), handler: () =>{
                    dispatch(hideAppDialog());

                    dispatch(deleteEntity(id, t))
                    .then(
                        response =>{
                            dispatch(setProcessing({processing:""}));
                        },
                        err => {
                            dispatch(setProcessing({processing:""}));

                            const handleResponseReceived = (state, dispatch, navigate, payload) => {
                                let errorMessages = payload?.data?.ErrorMessages;
            
                                if (!errorMessages || errorMessages.length == 0)
                                    errorMessages = [t("migrations.unknown_error")];
                                else
                                {
                                    errorMessages = getErrorMessages(errorMessages, 1);
            
                                    if (payload.data.ErrorCodes.EntityDoesNotExist)
                                        dispatch(removeEntityFromUI(id));                        
                                }
            
                                dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            const handleUnhandled = (state, dispatch, navigate, payload) =>{
                                let errorMessage = t("migrations.unknown_error");
                                dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
                        });
                }},
                noButton: {title: t("migrations.no")}
            }
        }));
    };
    /*delete */

    /*view/edit */
    const handleOnEntitySelected = (migrationId, item) => {
        if (blockNavigationIfDirty() == true)
            return;

        dispatch(loadEntity(migrationId, t))
        .then(
            response =>{
                
            },
            err =>
            {
                //hid eloader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                        errorMessages = [t("migrations.unknown_error")];
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);

                        if (payload.data.ErrorCodes.EntityDoesNotExist)
                            dispatch(removeEntityFromUI(migrationId));                        
                    }

                    dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    let errorMessage = t("migrations.unknown_error");
                    dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
            }
        );
    };
    /*view/edit */

    const handleOnAlertCheck = (item) => {
        let items = item.value;
        
        console.log("Alerts Checked", items)
        let entities = [...pageState.formValues.Entities.filter(e => e.EntityTypeId == 2)];
        if (items && items.length > 0)
            entities = [...entities, ...items];

        dispatch(setFormValue({id: "Entities", value: entities}));
    };

    const handleOnReportCheck = (item) => {
        let items = item.value;
        
        let entities = [...pageState.formValues.Entities.filter(e => e.EntityTypeId == 1)];
        if (items && items.length > 0)
            entities = [...entities, ...items];

        dispatch(setFormValue({id: "Entities", value: entities}));
    };

    /*apply migration*/
    const handleOnApply = (e) => {
        dispatch(setAppDialog({
            isVisible: true,
            className: "migrations-page-are-you-sure",
            title: t("migrations.warning"), content: t("migrations.areyousure1"),
            actions:{
                yesButton:{ title: t("migrations.yes"), handler: () =>{
                    dispatch(hideAppDialog());

                    dispatch(applyMigration(t))
                    .then(
                        response =>{
                        },
                        err => {
                            dispatch(setProcessing({processing:false}));

                            const handleResponseReceived = (state, dispatch, navigate, payload) => {
                                let errorMessages = payload?.data?.ErrorMessages;
            
                                if (!errorMessages || errorMessages.length == 0)
                                    errorMessages = [t("migrations.unknown_error")];
                                else
                                {
                                    errorMessages = getErrorMessages(errorMessages, 1);                   
                                }
            
                                dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            const handleUnhandled = (state, dispatch, navigate, payload) =>{
                                let errorMessage = t("migrations.unknown_error");
                                dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
                        });
                }},
                noButton: {title: t("migrations.no")}
            }
        }));
    };
    /*apply migration*/

    /*reapply migration*/
    const handleOnReapply = (e) => {
        dispatch(setAppDialog({
            isVisible: true,
            className: "migrations-page-are-you-sure",
            title:t("migrations.warning"), content: t("migrations.areyousure2"),
            actions:{
                yesButton:{ title: t("migrations.yes"), handler: () =>{
                    dispatch(hideAppDialog());

                    dispatch(reapplyMigration(t))
                    .then(
                        response =>{
                        },
                        err => {
                            dispatch(setProcessing({processing:false}));

                            const handleResponseReceived = (state, dispatch, navigate, payload) => {
                                let errorMessages = payload?.data?.ErrorMessages;
            
                                if (!errorMessages || errorMessages.length == 0)
                                    errorMessages = [t("migrations.unknown_error")];
                                else
                                {
                                    errorMessages = getErrorMessages(errorMessages, 1);              
                                }
            
                                dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            const handleUnhandled = (state, dispatch, navigate, payload) =>{
                                let errorMessage = t("migrations.unknown_error");
                                dispatch(addNotification({text: errorMessage, type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                            };
            
                            apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});                
                        });
                }},
                noButton: {title: t("migrations.no")}
            }
        }));
    };
    /*reapply migration*/


    return (
        <Fragment>
            <Page id="migrationsPage" className="migrations-page" title={t("migrations.migrations")} animation={props.animation}>
                <MigrationsPageBody 
                    onSplitterChange={handleOnSplitterChange} plansPanelRef={plansPanelRef} 
                    onPlanChange={handleOnPlanChange}                    
                    onNew={handleOnNew} onSave={handleOnSave} 
                    onActivate={handleOnActivate} onDeactivate={handleOnDeactivate} 
                    onApply={handleOnApply} onReapply= {handleOnReapply} onDelete={handleOnDelete}
                    onErrorbarClose={handleOnErrorbarClose}                            
                    onEntitySelected={handleOnEntitySelected} onMigrationDoubleClick={handleOnEntitySelected}                    
                    introItems={introItems}  
                    updateDirtyState={updateDirtyState}
                    getStatusText={getStatusText} onAlertCheck={handleOnAlertCheck} onReportCheck={handleOnReportCheck}
                />
            </Page>
            <style>
                {
                    `
                    /*page class*/
                    .migrations-page
                    {
                        background-color: transparent;
                        padding: ${currentTheme.pagePadding};
                    }

                    .migrations-page .k-splitbar.k-splitbar-horizontal
                    {
                        background-color: ${currentTheme.paneSeparatorBg};
                    }

                    .migrations-page .k-splitbar
                    {
                        width: ${currentTheme.paneSeparatorWidth};
                    }

                    /*are you sure to delete*/
                    .migrations-page-are-you-sure .k-widget
                    {
                        /*width of the dialog*/
                        width: 300px;
                    }    
                    
                    .migrations-page-are-you-sure .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }
                    `
                }
            </style>
        </Fragment>
    );
};

//export const ExpressionsPage = {Component: Expressions};
